export const LIGHT = '"Open Sans"';
export const REGULAR = '"Open Sans"';
export const BOLD = '"Open Sans"';
export const SEMIBOLD = '"Open Sans"';
export const JETBRAINS_MONO_REGULAR = '"JetBrains Mono"';
export const JETBRAINS_MONO_BOLD = '"JetBrains Mono"';
